import { MedicoesAtendimentosAnterioresQuery, TipoUnidadeForcaMuscular } from 'graphql/types.generated'
import { UnidadeForcaMuscularSelectModel } from 'view/atendimentos/components/MedicoesPanel/UnidadeForcaMuscularSelectField'
import { AtendimentoIndividualRetificacaoModel } from 'view/retificacao-atendimento/model-retificacaoAtendimento'

export interface MedicaoPeso {
  dataMedicao: Instant
  peso: string
}

export interface MedicaoQueryModel {
  valorPeso?: number
  valorAltura?: number
  valorImc?: number
  valorPerimetroCefalico?: number
  valorCircunferenciaAbdominal?: number
  perimetroPanturrilha?: number
  valorForcaMuscMaoDireita?: string
  unidadeForcaMuscMaoDireita?: TipoUnidadeForcaMuscular
  valorForcaMuscMaoEsquerda?: string
  unidadeForcaMuscMaoEsquerda?: TipoUnidadeForcaMuscular
  pele?: string
  olhoDireito?: string
  olhoEsquerdo?: string
  ouvidoDireito?: string
  ouvidoEsquerdo?: string
  membroInferiorDireito?: string
  membroInferiorEsquerdo?: string
  medicaoAnterior?: boolean
}

export enum OrigemDum {
  SEM_DUM,
  ATENDIMENTO_ANTERIOR,
  ATENDIMENTO_ATUAL,
  AMBOS,
}

export const STATUS_DUM_ATENDIMENTO_ATUAL: Set<OrigemDum> = new Set([OrigemDum.ATENDIMENTO_ATUAL, OrigemDum.AMBOS])

export const STATUS_DUM_ATENDIMENTO_ANTERIOR: Set<OrigemDum> = new Set([
  OrigemDum.ATENDIMENTO_ANTERIOR,
  OrigemDum.AMBOS,
])

export type MedicoesAtendimentoAnterior = MedicoesAtendimentosAnterioresQuery['medicoes'][0]
export type MedicoesNascimento = MedicoesAtendimentosAnterioresQuery['medicoesNoNascimento']
export type MedicoesRetificacaoQueryModel = AtendimentoIndividualRetificacaoModel['medicoes'][0]

export interface MedicaoAnteriorModel {
  id: ID
  data: string
  peso?: string
  altura?: string
  perimetroCefalico?: string
  medicoes?: { peso: number; altura: number; perimetroCefalico: number }
  valorForcaMuscMaoDireita?: string
  unidadeForcaMuscMaoDireita?: UnidadeForcaMuscularSelectModel
  valorForcaMuscMaoEsquerda?: string
  unidadeForcaMuscMaoEsquerda?: UnidadeForcaMuscularSelectModel
}

export const UNIDADE_FORCA_MUSCULAR: Record<
  TipoUnidadeForcaMuscular,
  {
    nome: string
    sigla: string
  }
> = {
  GRAMAFORCA: {
    nome: 'Gramas-força',
    sigla: 'gf',
  },
  LIBRAFORCA: {
    nome: 'Libra-força',
    sigla: 'lbf',
  },
  NEWTON: {
    nome: 'Newton',
    sigla: 'N',
  },
  QUILOGRAMAFORCA: {
    nome: 'Quilograma-força',
    sigla: 'kgf',
  },
}

export interface MedicaoOutrosAtendimentosImcModel {
  id: ID
  dataMedicao: Instant
  valorPeso?: number | null
  valorAltura?: number | null
}
